<template>
  <div class="material-page" :class="{ readonly: readonly }">
    <aside class="cat-panel">
      <div class="cat-hd">
        <span>材料分类</span>
        <div v-if="!readonly" class="cat-hd-actions">
          <el-button type="text" icon="el-icon-plus" title="新增分类" @click="openCatEdit()" />
        </div>
      </div>
      <div
        class="cat-all"
        :class="{ active: selectedCategoryId == null }"
        @click="selectCategory(null)"
      >全部分类</div>
      <el-tree
        ref="catTree"
        class="cat-tree"
        :data="categoryTree"
        node-key="id"
        :props="{ label: 'name', children: 'children' }"
        highlight-current
        default-expand-all
        :expand-on-click-node="false"
        @node-click="onCatNodeClick"
      >
        <span slot-scope="{ data }" class="cat-node">
          <span class="cat-label" :title="data.name">{{ data.name }}</span>
          <span v-if="!readonly" class="cat-ops" @click.stop>
            <i class="el-icon-plus" title="新增子分类" @click="openCatEdit(null, data.id)" />
            <i class="el-icon-edit" title="编辑" @click="openCatEdit(data)" />
            <i class="el-icon-delete" title="删除" @click="onCatDelete(data)" />
          </span>
        </span>
      </el-tree>
    </aside>

    <div class="mat-main">
      <div class="toolbar">
        <el-input v-model="keyword" clearable placeholder="材料名称" style="width:200px" @keyup.enter.native="load" />
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
        <el-button v-if="!readonly" type="primary" icon="el-icon-plus" @click="openEdit()">新增材料</el-button>
        <el-button v-if="!readonly" type="primary" icon="el-icon-upload2" @click="openImport">导入</el-button>
        <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
      </div>
      <el-table :data="pageList" border v-loading="loading">
        <el-table-column prop="name" label="材料名称" min-width="150" />
        <el-table-column label="分类" width="120">
          <template slot-scope="{ row }">{{ row.categoryName || row.category || '-' }}</template>
        </el-table-column>
        <el-table-column prop="spec" label="规格" width="120" />
        <el-table-column prop="unit" label="单位" width="80" />
        <el-table-column prop="costPrice" label="采购单价" width="90" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
        </el-table-column>
        <el-table-column prop="salePrice" label="销售单价" width="90" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.salePrice) }}</template>
        </el-table-column>
        <el-table-column prop="enabled" label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.enabled===1?'success':'info'">{{ row.enabled===1?'启用':'停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <list-pagination
        :total="listTotal"
        :page="page"
        :page-size="pageSize"
        @current-change="onPageChange"
        @size-change="onPageSizeChange"
      />
    </div>

    <el-dialog v-if="!readonly" :title="form.id?'编辑材料':'新增材料'" :visible.sync="visible" width="520px">

      <el-form :model="form" label-width="90px">
        <el-form-item label="分类" required>
          <el-cascader
            v-model="form.categoryId"
            :options="categoryTree"
            :props="leafCascaderProps"
            clearable
            filterable
            placeholder="请选择末级分类"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="名称" required><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="规格"><el-input v-model="form.spec" placeholder="与名称组合在租户内唯一" /></el-form-item>
        <el-form-item label="单位" required>
          <unit-select-with-add v-model="form.unit" />
        </el-form-item>
        <el-form-item label="采购单价">
          <el-input-number
            v-model="form.costPrice"
            :min="0"
            :precision="2"
            :step="1"
            controls-position="right"
            style="width:100%"
            placeholder="参考价，不填默认为 0"
          />
        </el-form-item>
        <el-form-item label="销售单价">
          <el-input-number
            v-model="form.salePrice"
            :min="0"
            :precision="2"
            :step="1"
            controls-position="right"
            style="width:100%"
            placeholder="参考价，不填默认为 0"
          />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
        <el-form-item label="状态"><el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog v-if="!readonly" :title="catForm.id?'编辑分类':'新增分类'" :visible.sync="catVisible" width="440px">
      <el-form :model="catForm" label-width="90px">
        <el-form-item label="分类名称" required>
          <el-input v-model="catForm.name" maxlength="64" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="上级分类">
          <el-cascader
            v-model="catForm.parentId"
            :options="parentCascaderOptions"
            :props="parentCascaderProps"
            clearable
            filterable
            placeholder="不选则为顶级"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="catForm.sortNo" :min="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="catVisible=false">取消</el-button>
        <el-button type="primary" :loading="catSaving" @click="saveCat">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="!readonly" title="导入材料" :visible.sync="importVisible" width="560px" @close="resetImport">
      <div class="import-steps">
        <p>1. 先下载模板，按表头填写后上传。</p>
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
        <div class="import-tips">
          <div class="import-tips-title">说明</div>
          <ol>
            <li>请从第2行开始填写，勿修改表头。</li>
            <li>分类名称必须是分类的最后一级。</li>
            <li>材料名称+规格不可与系统已有或文件内重复。</li>
            <li>全部校验通过后才会导入。</li>
          </ol>
        </div>
        <p style="margin-top:12px">2. 上传填写好的 Excel（.xlsx / .xls）。</p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
          :file-list="importFileList"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <div v-if="importErrors.length" class="import-errors">
        <div class="import-errors-title">
          校验未通过：总计 {{ importTotal }} 条，成功导入 0 条。问题如下：
        </div>
        <el-table :data="importErrors" border size="mini" max-height="280">
          <el-table-column prop="message" label="问题" min-width="220" />
          <el-table-column label="行号" min-width="160">
            <template slot-scope="{ row }">{{ row.rowText || (row.rows || []).join('，') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="importVisible=false">关闭</el-button>
        <el-button type="primary" :loading="importing" :disabled="!importFile" @click="doImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMaterials, saveMaterial, deleteMaterial,
  treeMaterialCategories, saveMaterialCategory, deleteMaterialCategory,
  downloadMaterialImportTemplate, importMaterials, exportMaterials
} from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import UnitSelectWithAdd from '../../components/UnitSelectWithAdd.vue'
import listPaging from '../../mixins/listPaging'

function cloneTreeWithout(nodes, excludeId) {
  const list = []
  ;(nodes || []).forEach(n => {
    if (n.id === excludeId) return
    const item = { id: n.id, name: n.name, parentId: n.parentId }
    if (n.children && n.children.length) {
      const kids = cloneTreeWithout(n.children, excludeId)
      if (kids.length) item.children = kids
    }
    list.push(item)
  })
  return list
}

export default {
  name: 'Material',
  components: { ListPagination, UnitSelectWithAdd },
  mixins: [listPaging],
  props: {
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: {},
      categoryTree: [],
      selectedCategoryId: null,
      catVisible: false,
      catSaving: false,
      catForm: {},
      importVisible: false,
      importing: false,
      exporting: false,
      importFile: null,
      importFileList: [],
      importErrors: [],
      importTotal: 0,
      leafCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false,
        checkStrictly: false
      },
      parentCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false,
        checkStrictly: true
      }
    }
  },
  computed: {
    parentCascaderOptions() {
      const excludeId = this.catForm && this.catForm.id
      return cloneTreeWithout(this.categoryTree, excludeId)
    }
  },
  created() {
    this.loadCategories().then(() => this.load())
  },
  methods: {
    async loadCategories() {
      const res = await treeMaterialCategories()
      this.categoryTree = res.data || []
      this.$nextTick(() => {
        if (this.selectedCategoryId != null && this.$refs.catTree) {
          this.$refs.catTree.setCurrentKey(this.selectedCategoryId)
        }
      })
    },
    selectCategory(id) {
      this.selectedCategoryId = id
      if (this.$refs.catTree) {
        this.$refs.catTree.setCurrentKey(id)
      }
      this.load()
    },
    onCatNodeClick(data) {
      this.selectCategory(data && data.id)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterials({
          keyword: this.keyword,
          categoryId: this.selectedCategoryId || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      this.form = row
        ? {
          ...row,
          costPrice: row.costPrice == null ? 0 : Number(row.costPrice),
          salePrice: row.salePrice == null ? 0 : Number(row.salePrice)
        }
        : {
          id: null,
          name: '',
          categoryId: this.selectedCategoryId || null,
          spec: '',
          unit: '',
          costPrice: 0,
          salePrice: 0,
          enabled: 1,
          remark: ''
        }
      this.visible = true
    },
    formatMoney(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      return Number.isFinite(n) ? n.toFixed(2) : '0.00'
    },
    async save() {
      if (!this.form.name) return this.$message.warning('请填写材料名称')
      if (!this.form.categoryId) return this.$message.warning('请选择末级分类')
      if (!this.form.unit) return this.$message.warning('请选择单位')
      this.saving = true
      try {
        const payload = {
          ...this.form,
          costPrice: this.form.costPrice == null || this.form.costPrice === '' ? 0 : this.form.costPrice,
          salePrice: this.form.salePrice == null || this.form.salePrice === '' ? 0 : this.form.salePrice
        }
        await saveMaterial(payload)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteMaterial(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    },
    openCatEdit(row, parentId) {
      if (row) {
        this.catForm = {
          id: row.id,
          name: row.name,
          parentId: row.parentId && row.parentId > 0 ? row.parentId : null,
          sortNo: row.sortNo == null ? 10 : row.sortNo
        }
      } else {
        const pid = parentId || this.selectedCategoryId || null
        this.catForm = {
          id: null,
          name: '',
          parentId: pid && pid > 0 ? pid : null,
          sortNo: 10
        }
      }
      this.catVisible = true
    },
    async saveCat() {
      if (!this.catForm.name) return this.$message.warning('请填写分类名称')
      this.catSaving = true
      try {
        const payload = {
          ...this.catForm,
          parentId: this.catForm.parentId || 0
        }
        await saveMaterialCategory(payload)
        this.$message.success('分类已保存')
        this.catVisible = false
        await this.loadCategories()
        this.load()
      } finally {
        this.catSaving = false
      }
    },
    onCatDelete(data) {
      this.$confirm(`确认删除分类「${data.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteMaterialCategory(data.id)
          this.$message.success('已删除')
          if (this.selectedCategoryId === data.id) {
            this.selectedCategoryId = null
          }
          await this.loadCategories()
          this.load()
        })
        .catch(() => {})
    },
    openImport() {
      this.resetImport()
      this.importVisible = true
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportMaterials({
          keyword: this.keyword || undefined,
          categoryId: this.selectedCategoryId || undefined
        })
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '材料档案.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    resetImport() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
      this.importing = false
    },
    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1)
      this.importFile = file.raw || null
      this.importErrors = []
      this.importTotal = 0
    },
    onImportFileRemove() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
    },
    async downloadTemplate() {
      try {
        const res = await downloadMaterialImportTemplate()
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '材料导入模板.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('模板下载失败')
      }
    },
    async doImport() {
      if (!this.importFile) return this.$message.warning('请先选择文件')
      this.importing = true
      this.importErrors = []
      try {
        const res = await importMaterials(this.importFile)
        const data = res.data || {}
        const total = data.total == null ? 0 : Number(data.total)
        const imported = data.imported == null ? 0 : Number(data.imported)
        this.importTotal = total
        if (data.ok) {
          this.$message.success(`导入完成：总计 ${total} 条，成功导入 ${imported} 条`)
          this.importVisible = false
          this.load()
        } else {
          this.importErrors = data.errors || []
          this.$message.error(`校验未通过：总计 ${total} 条，成功导入 0 条`)
        }
      } catch (e) { /* interceptor */ }
      finally {
        this.importing = false
      }
    }
  }
}
</script>

<style scoped>
.material-page {
  display: flex;
  gap: 12px;
  align-items: stretch;
  min-height: calc(100vh - 120px);
}
.cat-panel {
  width: 240px;
  flex-shrink: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  overflow: hidden;
}
.cat-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  color: #0f172a;
  font-size: 13px;
}
.cat-hd-actions .el-button {
  padding: 0 4px;
}
.cat-all {
  padding: 8px 12px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
}
.cat-all:hover,
.cat-all.active {
  background: #eff6ff;
  color: #1d4ed8;
}
.cat-tree {
  flex: 1;
  overflow: auto;
  padding: 8px 4px 12px;
  background: transparent;
}
.cat-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding-right: 4px;
  min-width: 0;
}
.cat-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.cat-ops {
  display: none;
  gap: 6px;
  color: #94a3b8;
  flex-shrink: 0;
}
.cat-ops i {
  cursor: pointer;
  font-size: 13px;
}
.cat-ops i:hover {
  color: #1d4ed8;
}
.cat-ops .el-icon-delete:hover {
  color: #ef4444;
}
.cat-node:hover .cat-ops {
  display: inline-flex;
}
.mat-main {
  flex: 1;
  min-width: 0;
}
.toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.import-steps {
  color: #334155;
  font-size: 13px;
  line-height: 1.6;
}
.import-tips {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-size: 12px;
  line-height: 1.7;
}
.import-tips-title {
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}
.import-tips ol {
  margin: 0;
  padding-left: 18px;
}
.import-errors {
  margin-top: 14px;
}
.import-errors-title {
  margin-bottom: 8px;
  color: #b91c1c;
  font-size: 13px;
}
</style>
